import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Grid,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Tooltip,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  TextField,
  InputAdornment,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Checkbox,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { ReactSortable } from "react-sortablejs";

import DynamicFlowsSection from "./components/dynamic_flows";
import ValidationRulesCard from "./components/validation_rules";
import LeadConnectorCard from "./components/lead_connector";
import FormulaFieldComponent from "./components/fields/formula_field";
import RelatedFieldComponent from "./components/fields/related_dropdown";
import FieldOptionsComponent from "./components/field_options";
import ValidationOptionsComponent from "./components/validation_options";
import PaymentFieldBuilderComponent from "./components/fields/payment_field";

function EditDataForm() {
  const title = "Edit Data Form";
  usePageTitle(title);

  const { id } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [resultData, setResultData] = useState(null);
  const [dataForm, setDataForm] = useState(null);
  const [dataFields, setDataFields] = useState([]);
  const [dataFormName, setDataFormName] = useState(null);
  const [formSuccessMessage, setFormSuccessMessage] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);
  const [dataFormFields, setDataFormFields] = useState([]);

  const [openAddSectionDialog, setOpenAddSectionDialog] = useState(false);
  const [openEditSectionDialog, setOpenEditSectionDialog] = useState(false);
  const [openAddFieldDialog, setOpenAddFieldDialog] = useState(false);
  const [openEditFieldDialog, setOpenEditFieldDialog] = useState(false);
  const [dataFormSectionName, setDataFormSectionName] = useState(null);
  const [dataFormSectionDescription, setDataFormSectionDescription] = useState(null);

  const [formFieldType, setFormFieldType] = useState(null);
  const [formFieldDisplayName, setFormFieldDisplayName] = useState(null);
  const [formFieldKey, setFormFieldKey] = useState(null);
  const [formFieldOptions, setFormFieldOptions] = useState([]);
  const [formFieldValidationParams, setFormFieldValidationParams] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [formFieldEditable, setFormFieldEditable] = useState(false);
  const [formFieldOptional, setFormFieldOptional] = useState(false);

  const [selectedDataFormSection, setSelectedDataFormSection] = useState(null);
  const [selectedDataFormSectionFields, setSelectedDataFormSectionFields] = useState([]);
  const [selectedFormFieldOptions, setSelectedFormFieldOptions] = useState([]);
  const [selectedFormFieldParamsOptions, setSelectedFormFieldParamsOptions] = useState(null);

  const [validationParams, setValidationParams] = useState(null);
  const [showFieldOptions, setShowFieldOptions] = useState(false);
  const [isRelatedFields, setIsRelatedFields] = useState(false);
  const [openAddRelatedOptionsDialog, setOpenAddRelatedOptionsDialog] = useState(false);
  const [relatedParentOption, setRelatedParentOption] = useState(null);
  const [relatedChildOptions, setRelatedChildOptions] = useState(null);
  const [relatedOptions, setRelatedOptions] = useState({});
  const [selectedRelatedOptionIndex, setSelectedRelatedOptionIndex] = useState(null);
  const [relatedParentField, setRelatedParentField] = useState(null);

  const [isFormula, setIsFormula] = useState(false);
  const [formula, setFormula] = useState(null);
  const [formulaParams, setFormulaParams] = useState([{}]);
  const addParam = () => {
    setFormulaParams([...formulaParams, {}]);
  };

  const [currentField, setCurrentField] = useState(null);
  const [fieldMeta, setFieldMeta] = useState(null);

  const [optionsList, setOptionsList] = useState([]);
  const [openOptionDialog, setOpenOptionDialog] = useState(false);
  const [optionName, setOptionName] = useState("");
  const [optionValue, setOptionValue] = useState("");

  const [selectedOptionsList, setSelectedOptionsList] = useState([]);
  const [editingOptionIndex, setEditingOptionIndex] = useState(null);

  const [openConnector, setOpenConnector] = useState(false);

  // const [isEditMode, setIsEditMode] = useState(false);

  function syncOptionsToString(list) {
    // let str = "";

    // list.forEach((opt) => {
    //   const name = opt.name?.trim();
    //   const value = opt.value?.trim();
    //   if (!name && !value) return;
    //   if (!name) return;
    //   const val = value || name;
    //   str += `${name}:${val},\n`;
    // });
    let str = "";

    list.forEach((opt) => {
      if (!opt.name || opt.name.trim().length === 0) return;

      const value = !opt.value || opt.value.trim().length === 0 ? opt.name : opt.value;

      str += `${opt.name}:${value},\n`;
    });

    setFormFieldOptions(str);
  }

  const syncEditOptionsToString = (list) => {
    let str = "";

    list.forEach((opt) => {
      if (!opt.name || opt.name.trim().length === 0) return;

      const value = !opt.value || opt.value.trim().length === 0 ? opt.name : opt.value;

      str += `${opt.name}:${value},\n`;
    });

    setSelectedFormFieldOptions(str);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/data_forms/${id}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setResultData(result.data.data);
            setDataFields(result.data.data.data_fields);
            setDataFormSections(result.data.data.data_form.form.sections);
            setDataFormName(result.data.data.data_form.title);
            setFormSuccessMessage(result.data.data.data_form.success_message);
            setDataForm(result.data.data.data_form);
            // console.log(result.data.data.data_form);
            if (selectedDataFormSection !== null) {
              result.data.data.data_form.form.sections.every((sect) => {
                if (sect.reference === selectedDataFormSection.reference) {
                  setSelectedDataFormSection(sect);
                  return false;
                }
                return true;
              });
            }

            const dfs = [];
            result.data.data.data_form.form.sections.forEach((sec) => {
              sec.fields.every((f) => {
                // if (!f.has_parent) {
                //   dfs.push(f);
                // }
                dfs.push(f);
                return true;
              });
            });
            setDataFormFields(dfs);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  useEffect(() => {
    if (selectedDataFormSection === null) {
      setSelectedDataFormSectionFields([]);
      return;
    }
    const tmp = [];
    selectedDataFormSection.fields.every((f) => {
      tmp.push(f);
      return true;
    });
    setSelectedDataFormSectionFields(tmp);
  }, [selectedDataFormSection]);

  async function editFormName() {
    if (dataFormName === null) {
      setErrMsg("Form name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      title: dataFormName,
      success_message: formSuccessMessage,
      reference: id,
    };
    await axios
      .post(`portal/data_forms/modify.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editSection() {
    if (dataFormSectionName === null) {
      setErrMsg("Section name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (dataFormSectionDescription === null) {
      setErrMsg("Section description is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setOpenEditSectionDialog(false);
    setShowLoading(true);
    const json = {
      title: dataFormSectionName,
      description: dataFormSectionDescription,
      reference: selectedSection.reference,
    };

    await axios
      .post(`portal/data_forms/sections/edit.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addSection() {
    if (dataFormSectionName === null) {
      setErrMsg("Section name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (dataFormSectionDescription === null) {
      setErrMsg("Section description is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setOpenAddSectionDialog(false);
    setShowLoading(true);
    const json = {
      title: dataFormSectionName,
      description: dataFormSectionDescription,
      fields: [],
      form: id,
    };
    // console.log(json);

    await axios
      .post("portal/data_forms/sections/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function duplicateSection(sectionReference) {
    setShowLoading(true);
    await axios
      .get(`portal/data_forms/sections/${sectionReference}/duplicate.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }
  async function reOrderSections() {
    const positions = [];
    dataFormSections.every((section, index) => {
      positions.push({
        reference: section.reference,
        position: index,
      });
      return true;
    });

    setShowLoading(true);
    const json = {
      sections: positions,
      form: id,
    };

    await axios
      .post("portal/data_forms/sections/re_order.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addField() {
    if (formFieldType === null) {
      setErrMsg("Field type is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (formFieldDisplayName === null) {
      setErrMsg("Field display name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    let metaData = fieldMeta;
    if (isRelatedFields) {
      if (!fieldMeta.related_options) {
        setErrMsg("Related options are required");
        setSeverity("error");
        setOpen(true);
        return;
      }

      // metaData = {
      //   related_options: relatedOptions,
      // };
    }

    if (currentField.field_type === "formula_field") {
      // console.log(fieldMeta);
      if (fieldMeta === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (fieldMeta.formula === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      const regex2 = /[+-/*()]/;
      if (!regex2.test(fieldMeta.formula)) {
        setErrMsg("Formula must contain an operator.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (formulaParams.length < 1) {
        setErrMsg("Too few formula parameters.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let error = "";
      let errorCount = 0;
      formulaParams.every((r) => {
        if (typeof r.field === "undefined" || r.field === null) {
          error = `All parameter fields are required`;
          errorCount += 1;
          return false;
        }
        return true;
      });

      if (errorCount > 0) {
        setErrMsg(error);
        setSeverity("error");
        setOpen(true);
        return;
      }

      metaData = {
        formula_field: {
          formula: fieldMeta.formula,
          parameters: formulaParams,
        },
      };
    }

    const json = {
      section: selectedSection.reference,
      // field_name: fieldName,
      field_type: formFieldType,
      display_name: formFieldDisplayName,
      custom_key: formFieldKey,
      options: formFieldOptions,
      validation_params: formFieldValidationParams,
      meta: metaData,
      editable: formFieldEditable,
      optional: formFieldOptional,
      parent: relatedParentField,
    };

    setOpenAddFieldDialog(false);
    setSelectedSection(null);
    setShowLoading(true);
    await axios
      .post(`/portal/data_forms/fields/create.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editField() {
    if (formFieldDisplayName === null) {
      setErrMsg("Field display name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    let metaData = fieldMeta;
    if (isRelatedFields) {
      // console.log(relatedOptions);
      if (relatedOptions === null) {
        setErrMsg("Related options are required");
        setSeverity("error");
        setOpen(true);
        return;
      }
      metaData = {
        related_options: relatedOptions,
      };
    }

    if (isFormula) {
      if (fieldMeta.formula === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      const regex2 = /[+-/*()]/;
      if (!regex2.test(formula)) {
        setErrMsg("Formula must contain an operator.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (formulaParams.length < 1) {
        setErrMsg("Too few formula parameters.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let error = "";
      let errorCount = 0;
      formulaParams.every((r) => {
        if (typeof r.field === "undefined" || r.field === null) {
          error = `All parameter fields are required`;
          errorCount += 1;
          return false;
        }
        return true;
      });

      if (errorCount > 0) {
        setErrMsg(error);
        setSeverity("error");
        setOpen(true);
        return;
      }

      metaData = {
        formula_field: {
          // formula: `${formula}`,
          formula: fieldMeta.formula,
          parameters: formulaParams,
        },
      };
    }

    const json = {
      reference: selectedField.reference,
      field_type: formFieldType,
      display_name: formFieldDisplayName,
      custom_key: formFieldKey,
      options: selectedFormFieldOptions,
      validation_params: formFieldValidationParams,
      meta: metaData,
      editable: formFieldEditable,
      optional: formFieldOptional,
      parent: relatedParentField,
    };

    setOpenEditFieldDialog(false);
    setSelectedField(null);
    setShowLoading(true);
    await axios
      .post(`/portal/data_forms/fields/edit.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeSection(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/sections/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeField(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/fields/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    setFormFieldOptions([]);
    setFormFieldValidationParams(null);
    setFieldMeta(null);
    // setFormFieldEditable(false);

    dataFields.every((param) => {
      if (param.reference === formFieldType) {
        if (param.validation_params.length > 0) {
          setValidationParams(param.validation_params);
        } else {
          setValidationParams(null);
        }

        if (param.options_reqd) {
          setShowFieldOptions(true);
        } else {
          setShowFieldOptions(false);
        }

        if (param.related_field) {
          setIsRelatedFields(true);
        } else {
          setIsRelatedFields(false);
        }

        if (param.field_type === "formula_field") {
          setIsFormula(true);
        } else {
          setIsFormula(false);
        }

        setCurrentField(param);
        return false;
      }
      return true;
    });
  }, [formFieldType]);

  function sectionHighlight(section) {
    if (selectedDataFormSection === null) {
      return "outlined";
    }
    if (section.reference === selectedDataFormSection.reference) {
      return "contained";
    }

    return "outlined";
  }

  async function reOrderSectionFields() {
    const positions = [];
    selectedDataFormSectionFields.every((field, index) => {
      positions.push({
        reference: field.reference,
        position: index,
      });
      return true;
    });

    setShowLoading(true);
    const json = {
      fields: positions,
      section: selectedDataFormSection.reference,
      form: id,
    };

    await axios
      .post("portal/data_forms/sections/fields/re_order.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          // setSelectedDataFormSection(null);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function readOptionsCSV(file) {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = function (event) {
        const csv = event.target.result;
        const lines = csv.trim().split("\n");
        let string = "";

        /* eslint-disable no-restricted-syntax, no-continue, prefer-destructuring */
        let i = 0;
        for (const line of lines) {
          if (line === undefined || line.trim().length === 0) {
            continue;
          }

          if (i === 0) {
            i += 1;
            continue;
          }

          let name = "";
          let value = "";
          const values = line.split(",");
          if (values.length > 1) {
            if (values[0].trim().length === 0) {
              continue;
            }
            name = values[0];
            if (values[1].trim().length === 0) {
              value = values[0];
            } else {
              value = values[1];
            }
          } else {
            name = line;
            value = line;
          }

          string += `${name}:${value},\n`;
          i += 1;
        }
        resolve(string);
      };

      reader.onerror = function () {
        reject(new Error("Error reading file"));
        resolve(false);
      };

      reader.readAsText(file);
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openOptionDialog} fullWidth maxWidth="xs">
        <DialogTitle>Add Option</DialogTitle>

        <DialogContent>
          <MDBox mt={2}>
            <MDInput
              label="Name"
              fullWidth
              value={optionName}
              onChange={(e) => setOptionName(e.target.value)}
            />
          </MDBox>

          <MDBox mt={2}>
            <MDInput
              label="Value (optional)"
              fullWidth
              value={optionValue}
              onChange={(e) => setOptionValue(e.target.value)}
            />
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton onClick={() => setOpenOptionDialog(false)}>Cancel</MDButton>

          <MDButton
            color="dark"
            onClick={() => {
              if (!optionName?.trim()) return;

              const value =
                !optionValue || optionValue.trim().length === 0
                  ? optionName.trim()
                  : optionValue.trim();

              const isEditMode = openEditFieldDialog;

              const sourceList = selectedOptionsList; // isEditMode ? selectedOptionsList : optionsList;
              const newList = [...sourceList];

              if (editingOptionIndex !== null) {
                newList[editingOptionIndex] = {
                  name: optionName.trim(),
                  value,
                };
              } else {
                newList.push({
                  name: optionName.trim(),
                  value,
                });
              }

              if (isEditMode) {
                setSelectedOptionsList(newList);
                syncEditOptionsToString(newList);
              } else {
                // setOptionsList(newList);
                setSelectedOptionsList(newList);
                syncOptionsToString(newList);
              }

              // reset
              setOptionName("");
              setOptionValue("");
              setEditingOptionIndex(null);
              setOpenOptionDialog(false);
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openAddSectionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Section</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                multiline
                rows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionDescription(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddSectionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              addSection();
            }}
          >
            Add Section
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditSectionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Section</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                value={dataFormSectionName}
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={dataFormSectionDescription}
                multiline
                rows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionDescription(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditSectionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              editSection();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddFieldDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Field Type</InputLabel>
                <Select
                  label="Field Type"
                  onChange={(e) => {
                    setFormFieldValidationParams(null);
                    setFormFieldOptions([]);
                    setOptionsList([]); // ✅ prevents carryover between types
                    setSelectedOptionsList([]);
                    setFormFieldType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataFields.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.name}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            {formFieldType && (
              <MDBox>
                <MDBox>
                  <MDBox>
                    <MDBox mt={4}>
                      <MDInput
                        name="name"
                        margin="dense"
                        label="Display Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setFormFieldDisplayName(e.target.value)}
                      />
                    </MDBox>
                    <MDBox mt={2}>
                      <MDInput
                        name="custom_key"
                        margin="dense"
                        label="Custom Key (Optional)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setFormFieldKey(e.target.value)}
                      />
                    </MDBox>
                    <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                      <Checkbox
                        checked={formFieldOptional}
                        onChange={(e) => {
                          setFormFieldOptional(e.target.checked);
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                      >
                        &nbsp;&nbsp;Make optional?
                      </MDTypography>
                    </MDBox>

                    <ValidationOptionsComponent
                      validationParams={validationParams}
                      formFieldValidationParams={formFieldValidationParams}
                      setFormFieldValidationParams={setFormFieldValidationParams}
                      selectedFormFieldParamsOptions={selectedFormFieldParamsOptions}
                    />

                    {showFieldOptions && (
                      <FieldOptionsComponent
                        optionsList={selectedOptionsList}
                        setOptionsList={setSelectedOptionsList}
                        syncOptionsToString={syncOptionsToString}
                        optionName={optionName}
                        setOptionName={setOptionName}
                        optionValue={optionValue}
                        setOptionValue={setOptionValue}
                        setOpenOptionDialog={setOpenOptionDialog}
                        setEditingOptionIndex={setEditingOptionIndex}
                        readOptionsCSV={readOptionsCSV}
                        formFieldEditable={formFieldEditable}
                        setFormFieldEditable={setFormFieldEditable}
                      />
                    )}
                  </MDBox>

                  {currentField && currentField.field_type === "formula_field" && (
                    <FormulaFieldComponent
                      fieldMeta={fieldMeta}
                      setFieldMeta={setFieldMeta}
                      formulaParams={formulaParams}
                      setFormulaParams={setFormulaParams}
                      addParam={addParam}
                      dataFormFields={dataFormFields}
                    />
                  )}
                  {currentField && currentField.field_type === "related_dropdown" && (
                    <RelatedFieldComponent
                      dataFormFields={dataFormFields}
                      setFieldMeta={setFieldMeta}
                      setRelatedParentField={setRelatedParentField}
                    />
                  )}
                  {currentField && currentField.field_type === "payment_field" && (
                    <PaymentFieldBuilderComponent
                      dataFormFields={dataFormFields}
                      fieldMeta={fieldMeta}
                      setFieldMeta={setFieldMeta}
                      initialMeta={selectedField?.options}
                    />
                  )}
                </MDBox>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setFormFieldType(null);
              setValidationParams(null);
              setFormFieldOptions(null);
              setRelatedParentField(null);
              setOpenAddFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              if (formFieldType === null) {
                setSeverity("error");
                setErrMsg("Field type is required.");
                setOpen(true);
                return;
              }
              if (formFieldDisplayName === null || formFieldDisplayName === "") {
                setSeverity("error");
                setErrMsg("Field display name is required.");
                setOpen(true);
                return;
              }

              if (isRelatedFields) {
                if (relatedParentField === null) {
                  setSeverity("error");
                  setErrMsg("Related parent field is required.");
                  setOpen(true);
                  return;
                }
              }
              addField();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditFieldDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox>
              {selectedField && (
                <MDBox mt={1}>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Field Type</InputLabel>
                    <Select
                      label="Field Type"
                      onChange={(e) => {
                        setFormFieldValidationParams(null);
                        // setFormFieldOptions([]);
                        setFormFieldType(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                      defaultValue={selectedField.data_field.reference}
                    >
                      {
                        // --> Notice below changes
                        dataFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          dataFields.map((record) => (
                            <MenuItem value={`${record.reference}`}>{record.name}</MenuItem>
                          ))
                      }
                    </Select>
                  </FormControl>
                </MDBox>
              )}
              <MDBox mt={3}>
                <MDInput
                  value={formFieldDisplayName}
                  name="name"
                  margin="dense"
                  label="Display Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setFormFieldDisplayName(e.target.value)}
                />
              </MDBox>

              <MDBox mt={2}>
                <MDInput
                  name="custom_key"
                  margin="dense"
                  label="Custom Key (Optional)"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={formFieldKey}
                  onChange={(e) => setFormFieldKey(e.target.value)}
                />
              </MDBox>
              <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                <Checkbox
                  checked={formFieldOptional}
                  onChange={(e) => {
                    setFormFieldOptional(e.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Make optional?
                </MDTypography>
              </MDBox>

              <ValidationOptionsComponent
                validationParams={validationParams}
                formFieldValidationParams={formFieldValidationParams}
                setFormFieldValidationParams={setFormFieldValidationParams}
                selectedFormFieldParamsOptions={selectedFormFieldParamsOptions}
              />

              {showFieldOptions && (
                <FieldOptionsComponent
                  optionsList={selectedOptionsList}
                  setOptionsList={setSelectedOptionsList}
                  syncOptionsToString={syncEditOptionsToString}
                  setOptionName={setOptionName}
                  setOptionValue={setOptionValue}
                  setOpenOptionDialog={setOpenOptionDialog}
                  setEditingOptionIndex={setEditingOptionIndex}
                  readOptionsCSV={readOptionsCSV}
                  formFieldEditable={formFieldEditable}
                  setFormFieldEditable={setFormFieldEditable}
                  isEdit={true}
                />
              )}

              {isRelatedFields && (
                <RelatedFieldComponent
                  dataFormFields={dataFormFields}
                  setFieldMeta={setFieldMeta}
                  setRelatedParentField={setRelatedParentField}
                  initialParentField={relatedParentField}
                  initialRelatedOptions={relatedOptions}
                />
              )}

              {isFormula && (
                <FormulaFieldComponent
                  fieldMeta={fieldMeta}
                  setFieldMeta={setFieldMeta}
                  formulaParams={formulaParams}
                  setFormulaParams={setFormulaParams}
                  addParam={addParam}
                  dataFormFields={dataFormFields}
                  initialMeta={selectedField?.options}
                />
              )}
              {currentField && currentField.field_type === "payment_field" && (
                <PaymentFieldBuilderComponent
                  dataFormFields={dataFormFields}
                  fieldMeta={fieldMeta}
                  setFieldMeta={setFieldMeta}
                  initialMeta={selectedField?.options}
                />
              )}
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditFieldDialog(false);
              setValidationParams(null);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              if (formFieldDisplayName === null || formFieldDisplayName === "") {
                setSeverity("error");
                setErrMsg("Field display name is required.");
                setOpen(true);
                return;
              }

              if (isRelatedFields) {
                if (relatedParentField === null) {
                  setSeverity("error");
                  setErrMsg("Related parent field is required.");
                  setOpen(true);
                  return;
                }
              }
              editField();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      {dataForm !== null && (
        <MDBox pt={1.5} pb={3} mb={3}>
          <MDBox display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/data-forms`);
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>attribution</Icon>}
                onClick={() => {
                  setOpenConnector(true);
                }}
              >
                Lead Connector
              </Button>
            </MDBox>
          </MDBox>
          <MDBox mt={0}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Data Form
                      </MDTypography>
                      <MDBox mt={2}>
                        <MDInput
                          value={dataFormName}
                          name="name"
                          margin="dense"
                          label="Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setDataFormName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2}>
                        <MDInput
                          value={formSuccessMessage}
                          placeholder="Enter a message to display upon successful submission."
                          multiline
                          minRows={3}
                          name="name"
                          margin="dense"
                          label="Submission Success Message"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFormSuccessMessage(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2} align="right">
                        <MDButton
                          size="small"
                          color="dark"
                          variant="outlined"
                          onClick={() => {
                            editFormName();
                          }}
                        >
                          Save Changes
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={3}>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox p={3}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          Form Sections
                        </MDTypography>
                        <Tooltip title="Add Section">
                          <MDButton
                            variant="outlined"
                            color="dark"
                            iconOnly
                            size="small"
                            onClick={() => {
                              setOpenAddSectionDialog(true);
                              setDataFormSectionName(null);
                              setDataFormSectionDescription(null);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </Tooltip>
                      </MDBox>
                      <MDBox>
                        <Divider />
                      </MDBox>
                      {dataFormSections.length > 0 ? (
                        <>
                          <MDBox mt={3} id="sortableSections">
                            <ReactSortable list={dataFormSections} setList={setDataFormSections}>
                              {
                                // --> Notice below changes
                                dataFormSections.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  dataFormSections.map((record, index) => (
                                    <MDBox mb={3}>
                                      <Grid container spacing={0}>
                                        <Grid item xs={1} md={1} lg={1}>
                                          <MDBox display="flex" alignItems="center" pt={1}>
                                            {/* <Icon fontSize="medium">swap_vert</Icon> */}
                                            <Icon fontSize="medium">drag_indicator</Icon>
                                          </MDBox>
                                        </Grid>
                                        <Grid item xs={11} md={11} lg={11}>
                                          <MDBox mb={2}>
                                            <MDBox
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="right"
                                            >
                                              <MDBox df_ref={`${index}`}>
                                                <MDTypography variant="h6" fontWeight="regular">
                                                  {record.title}
                                                </MDTypography>
                                              </MDBox>
                                              <MDBox align="right">
                                                <Tooltip title="Edit Fields">
                                                  <MDButton
                                                    size="small"
                                                    variant={sectionHighlight(record)}
                                                    iconOnly
                                                    circular
                                                    color="dark"
                                                    onClick={() => {
                                                      setSelectedDataFormSection(record);
                                                      // setSelectedDataFormSectionFields(record.fields);
                                                    }}
                                                  >
                                                    <Icon>dynamic_form</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                                &nbsp;|&nbsp;
                                                <Tooltip title="Edit Section">
                                                  <MDButton
                                                    size="small"
                                                    variant="outlined"
                                                    iconOnly
                                                    circular
                                                    color="warning"
                                                    onClick={() => {
                                                      setDataFormSectionName(record.title);
                                                      setDataFormSectionDescription(
                                                        record.description
                                                      );
                                                      setSelectedSection(record);
                                                      setOpenEditSectionDialog(true);
                                                    }}
                                                  >
                                                    <Icon>edit</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                                &nbsp;
                                                <Tooltip title="Duplicate Section">
                                                  <MDButton
                                                    size="small"
                                                    variant="outlined"
                                                    iconOnly
                                                    circular
                                                    color="info"
                                                    onClick={() => {
                                                      if (
                                                        window.confirm(
                                                          "Duplicate this section and all its form fields?"
                                                        ) === true
                                                      ) {
                                                        duplicateSection(record.reference);
                                                      }
                                                    }}
                                                  >
                                                    <Icon>copy</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                                &nbsp;
                                                <Tooltip title="Delete Section">
                                                  <MDButton
                                                    size="small"
                                                    variant="outlined"
                                                    iconOnly
                                                    circular
                                                    color="error"
                                                    onClick={() => {
                                                      if (
                                                        window.confirm(
                                                          `Delete section? All previously captured data will be lost. This action is not reversible.`
                                                        ) === true
                                                      ) {
                                                        removeSection(record.reference);
                                                      }
                                                    }}
                                                  >
                                                    <Icon>close</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                              </MDBox>
                                            </MDBox>
                                            <MDBox>
                                              <MDTypography variant="h6" fontWeight="light">
                                                {record.description}
                                              </MDTypography>
                                            </MDBox>
                                          </MDBox>
                                        </Grid>
                                      </Grid>
                                    </MDBox>
                                  ))
                              }
                            </ReactSortable>
                          </MDBox>

                          <MDBox mt={1}>
                            <Divider />
                            <MDTypography variant="subtitle2" fontSize={14} align="center">
                              Drag sections to re-order your data form accordingly.
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={3} align="right">
                            <MDButton
                              size="small"
                              color="dark"
                              variant="outlined"
                              onClick={() => {
                                reOrderSections();
                              }}
                            >
                              Save Changes
                            </MDButton>
                          </MDBox>
                        </>
                      ) : (
                        <MDBox mt={1} align="center">
                          <MDBox>
                            <MDTypography variant="h6" fontSize={48}>
                              <Icon>category</Icon>
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                              Organise your form in sections. Give your users a consistent
                              experience.
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      )}
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ width: "100%", marginTop: "10px" }}>
                  <MDBox p={3} display="flex" justifyContent="space-between">
                    <MDTypography variant="h6" fontWeight="medium">
                      Section Fields
                    </MDTypography>
                    <MDBox>
                      <Icon color="dark">dynamic_form</Icon>
                    </MDBox>
                  </MDBox>
                </Card>
                <MDBox mt={3}>
                  {selectedDataFormSection != null ? (
                    <MDBox mb={3}>
                      <Card sx={{ width: "100%", marginTop: "10px" }}>
                        <MDBox p={2}>
                          <MDBox
                            mb={2}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="bold">
                                {selectedDataFormSection.title}
                              </MDTypography>
                            </MDBox>
                            <Tooltip title="Add Field">
                              <MDButton
                                variant="outlined"
                                color="dark"
                                size="small"
                                iconOnly
                                onClick={() => {
                                  setSelectedSection(selectedDataFormSection);
                                  setFormFieldType(null);
                                  setFormFieldDisplayName(null);
                                  setFormFieldKey(null);
                                  setFormFieldOptions([]);
                                  setOptionsList([]);
                                  setSelectedOptionsList([]);
                                  setFormFieldValidationParams(null);
                                  setValidationParams(null);
                                  setRelatedOptions({});
                                  setIsRelatedFields(false);
                                  setOpenAddFieldDialog(true);
                                  setFormFieldEditable(false);
                                  setFormFieldOptional(false);
                                }}
                              >
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                              </MDButton>
                            </Tooltip>
                          </MDBox>
                          <MDBox>
                            <ReactSortable
                              list={selectedDataFormSectionFields}
                              setList={setSelectedDataFormSectionFields}
                            >
                              {
                                // --> Notice below changes
                                selectedDataFormSectionFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  selectedDataFormSectionFields.map((field, idx) => (
                                    <MDBox df_ref={`${idx}`} mb={2}>
                                      <ListItem>
                                        <ListItemIcon>
                                          <MDBox variant="button">
                                            <Icon>drag_indicator</Icon>
                                          </MDBox>
                                        </ListItemIcon>
                                        <ListItemText
                                          primary={
                                            <MDTypography variant="caption" fontWeight="light">
                                              {field.field_name}{" "}
                                              {field.is_optional ? "(Optional)" : ""}
                                            </MDTypography>
                                          }
                                          secondary={
                                            <MDTypography variant="h6" fontWeight="regular">
                                              {field.display_name}
                                            </MDTypography>
                                          }
                                        />
                                        <MDBox>
                                          <span>
                                            <Tooltip title="Edit Field">
                                              <MDButton
                                                size="small"
                                                variant="outlined"
                                                iconOnly
                                                circular
                                                color="warning"
                                                onClick={() => {
                                                  // console.log(field);
                                                  setSelectedField(field);
                                                  setFormFieldType(field.data_field.reference);
                                                  setFormFieldDisplayName(field.display_name);
                                                  setFormFieldKey(field.custom_key);
                                                  setFormFieldEditable(field.editable);
                                                  setFormFieldOptional(field.is_optional);
                                                  if (field.data_field.related_field) {
                                                    setRelatedParentField(field.parent.reference);

                                                    const opts = {};
                                                    for (const [key, value] of Object.entries(
                                                      field.options
                                                    )) {
                                                      console.log(`${key}: ${value}`);
                                                      let vOpts = "";
                                                      value.every((param) => {
                                                        vOpts += `${param.name}:${param.value},\n`;
                                                        return true;
                                                      });
                                                      opts[key] = vOpts;
                                                    }
                                                    setRelatedOptions(opts);

                                                    setIsRelatedFields(true);
                                                    setOpenEditFieldDialog(true);
                                                    return;
                                                  }

                                                  if (
                                                    field.data_field.field_type === "formula_field"
                                                  ) {
                                                    setIsFormula(true);
                                                    setFormula(field.options.formula);
                                                    setFormulaParams(field.options.parameters);
                                                    setOpenEditFieldDialog(true);
                                                    return;
                                                  }
                                                  // if (
                                                  //   field.data_field.field_type === "payment_field"
                                                  // ) {
                                                  //   setFieldMeta(field.options);
                                                  //   setOpenEditFieldDialog(true);
                                                  //   return;
                                                  // }

                                                  setShowFieldOptions(false);
                                                  setValidationParams(null);
                                                  // if (field.data_field.options_reqd) {
                                                  //   setShowFieldOptions(true);
                                                  //   let opts = "";
                                                  //   field.options.every((param) => {
                                                  //     opts += `${param.name}:${param.value},\n`;
                                                  //     return true;
                                                  //   });
                                                  //   // console.log(opts);
                                                  //   setSelectedFormFieldOptions(opts);
                                                  //   setFormFieldOptions(opts);
                                                  //   setValidationParams(null);
                                                  //   setOpenEditFieldDialog(true);
                                                  //   return;
                                                  // }
                                                  if (field.data_field.options_reqd) {
                                                    setShowFieldOptions(true);

                                                    let opts = "";
                                                    const arr = [];

                                                    field.options.every((param) => {
                                                      opts += `${param.name}:${param.value},\n`;

                                                      // 👇 THIS WAS MISSING
                                                      arr.push({
                                                        name: param.name,
                                                        value: param.value,
                                                      });

                                                      return true;
                                                    });

                                                    setSelectedFormFieldOptions(opts);
                                                    setFormFieldOptions(opts);

                                                    // 👇 CRITICAL FIX
                                                    setSelectedOptionsList(arr);

                                                    setValidationParams(null);
                                                    setOpenEditFieldDialog(true);
                                                    return;
                                                  }

                                                  if (
                                                    Object.keys(
                                                      field.data_field.pre_validation_params
                                                    ).length > 0
                                                  ) {
                                                    // console.log(field.data_field.pre_validation_params);
                                                    setFormFieldValidationParams(
                                                      field.options ? field.options : {}
                                                    );
                                                    setValidationParams(
                                                      field.data_field.pre_validation_params
                                                    );
                                                    setSelectedFormFieldParamsOptions(
                                                      field.options
                                                    );
                                                  }

                                                  setOpenEditFieldDialog(true);
                                                }}
                                              >
                                                <Icon>edit</Icon>
                                              </MDButton>
                                            </Tooltip>
                                            &nbsp;
                                          </span>
                                          <Tooltip title="Delete Field">
                                            <MDButton
                                              size="small"
                                              variant="outlined"
                                              iconOnly
                                              circular
                                              color="error"
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    `Delete field? All previously collected data will be lost. This action is not reversible.`
                                                  ) === true
                                                ) {
                                                  removeField(field.reference);
                                                }
                                              }}
                                            >
                                              <Icon>close</Icon>
                                            </MDButton>
                                          </Tooltip>
                                        </MDBox>
                                      </ListItem>
                                    </MDBox>
                                  ))
                              }
                            </ReactSortable>
                          </MDBox>
                          <MDBox mt={3}>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} align="right">
                            <MDButton
                              size="small"
                              color="dark"
                              variant="outlined"
                              onClick={() => {
                                reOrderSectionFields();
                              }}
                            >
                              Save Changes
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ) : (
                    <MDBox>
                      <Card>
                        <MDBox p={3} align="center">
                          <MDTypography variant="subtitle2" fontSize={32}>
                            <Icon>dynamic_form</Icon>
                          </MDTypography>
                          <MDTypography variant="subtitle2">No form section selected.</MDTypography>
                        </MDBox>
                      </Card>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={3}>
            <ValidationRulesCard
              dataFormRef={id}
              triggerRefresh={triggerRefresh}
              rules={resultData.rules}
              formRules={resultData.data_form_rules}
              dataFormFields={dataFormFields}
            />
          </MDBox>
          <MDBox mt={3}>
            <DynamicFlowsSection
              dataFormRef={id}
              navigationLogics={resultData.logics}
              navigationLogicFields={resultData.logic_fields}
              dataFormFields={dataFormFields}
              dataFormSections={dataFormSections}
              triggerRefresh={triggerRefresh}
            />
          </MDBox>
          <LeadConnectorCard
            dataFormRef={id}
            triggerRefresh={triggerRefresh}
            leadConnector={resultData.lead_connector}
            leadBuckets={resultData.buckets}
            dataFormFields={dataFormFields}
            openDialog={openConnector}
            onClose={() => setOpenConnector(false)}
          />
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default EditDataForm;
